import { noop } from 'underscore';

export default {
  handler: 'liveChat',
  data: noop,
};
